import { Alert, Button, Card, Col, Layout, Row, Skeleton, theme } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import { initPrestationSlice } from "../Slices/Prestation.slice";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import routes from "../../../engine/routes";
import {
  daysJsFormat,
  isUrgent,
  roles,
  statusPrestationsValues,
} from "../../../utils/constants";
import useDeviceDetect from "../../../engine/hooks/useDeviceDetect";
import "./prices.css";
import dayjs from "../../../utils/dayjs";

import {
  ActionRoleSpecific,
  onlyRoleMapping,
  UserCanDoActionMemo,
} from "../../../engine/AuthRoute";
import { UserContext } from "../../../engine/context/User.context";
import { PrestationHeader } from "../../../shared/components/PrestationHeader/PrestationHeader";
import { PrestationEstimationCost } from "./PrestationEstimationCost";
import { PrestationResumeCards } from "./PrestationResumeCards";
import {
  RenderApprovalButtons,
  RenderButtonDraftToNextStage,
  RenderButtonsInterpreteAcceptRefuse,
  RenderCancelAt,
  RenderCommentAdmin,
  RenderNeedApprovalAlert,
  RenderStatusInterprete,
} from "./PrestationsResumeActions";
import { PrestationSigning } from "./PrestationSigning";
import moment from "moment";

const { Content, Sider, Header, Footer } = Layout;

export function PrestationResume({ isNew }) {
  const { id } = useParams();
  const { prestation, loading, loadingAppel } = useSelector(
    state => state.prestation,
  );
  const elementsRef = useRef({});

  const isFinish = [
    statusPrestationsValues.finish,
    statusPrestationsValues.finish_notsigned,
    statusPrestationsValues.finish_permanance,
  ].includes(prestation.status);

  const registerRef = (key, element) => {
    elementsRef.current[key] = element;
  };

  const [toApproved, setToApproved] = useState([]);

  useEffect(() => {
    let arr = [];
    if (prestation?.changes !== undefined) {
      Object.keys(prestation?.changes).map(e => {
        if (prestation.changes[e].needsApproval) {
          arr.push({ value: prestation.changes[e], key: e });
        }
      });
      setToApproved(arr);
    }
  }, [prestation]);

  const { user } = useContext(UserContext);

  const { init, clear } = initPrestationSlice({ id });

  const dispatch = useDispatch();

  const formRef = useRef(null);

  const { status } = prestation;

  const { isMobile } = useDeviceDetect();

  const {
    token: { colorPrimary },
  } = theme.useToken();

  let finderStatusInterprete = prestation.interpretesStatus.find(
    e => e.interprete._id === user._id,
  );

  const renderFinishAt = () => {
    if (isFinish || prestation?.interventionFinal.finishAt !== null) {
      let date = dayjs(prestation.interventionFinal.finishAt).format(
        daysJsFormat.full,
      );
      return (
        <Col span={24}>
          <Alert
            message={`Prestation terminée le ${date}`}
            type="success"
            showIcon
            closable={true}
          />
        </Col>
      );
    } else {
      return null;
    }
  };

  const renderButtonsAnswer = () => {
    if (
      finderStatusInterprete === undefined ||
      finderStatusInterprete.answer !== undefined
    ) {
      return null;
    }

    return <RenderButtonsInterpreteAcceptRefuse />;
  };

  const finishAndSave = () => {
    formRef.current.submit();
  };

  const formDisabledResume = () => {
    if (user.role === roles.admin || user.role === roles.permanance) {
      return false;
    }

    if (user.role === roles.institution) {
      return true;
    }

    const today = dayjs();
    const startDate = dayjs(prestation?.intervention?.startDate);
    startDate.isAfter(today, "day");

    if (isFinish || startDate.isAfter(today, "day")) {
      return true;
    }

    return false;
  };

  const isEstimation = [
    statusPrestationsValues.draft,
    statusPrestationsValues.waiting,
    statusPrestationsValues.planned,
  ].includes(prestation.status);

  const renderNotReady = () => {};

  let copy = JSON.parse(JSON.stringify(finderStatusInterprete || {}));

  const invitationSentAt = copy?.emailsSent?.sort(
    (a, b) => new Date(a.send_at) - new Date(b.send_at),
  )[0]?.send_at;

  let canAsnwerInvitation = true;

  if (copy?.emailsSent !== null) {
    canAsnwerInvitation =
      dayjs(invitationSentAt).isSameOrBefore(dayjs(), "minute") ||
      isUrgent(prestation) ||
      prestation.interprete?._id === user._id;
  }

  return (
    <div id={"layout-content"}>
      <Row gutter={isMobile ? [0, 0] : [20, 20]} className={"resume-main"}>
        {loading ? (
          <>
            <Col span={24}>
              <Skeleton.Input size={{ width: "100%" }} />
            </Col>
            <Col span={24}>
              <Card style={{ width: "100%" }} loading={true}></Card>
            </Col>
            <Col span={12}>
              <Card style={{ width: "100%" }} loading={true}></Card>
            </Col>
            <Col span={12}>
              <Card style={{ width: "100%" }} loading={true}></Card>
            </Col>
            <Col span={24}>
              <Skeleton.Button />
              <Skeleton.Button />
            </Col>
          </>
        ) : (
          <>
            {canAsnwerInvitation || !onlyRoleMapping([roles.interprete]) ? (
              <>
                <PrestationHeader
                  title={routes.prestations(id).detailResume.title}
                />
                <Col span={24}>
                  <RenderStatusInterprete
                    statusInterprete={finderStatusInterprete}
                  />
                </Col>
                <RenderCommentAdmin key={prestation._id} />

                <RenderCancelAt />
                {prestation._id !== undefined && !loading
                  ? renderFinishAt()
                  : null}

                <RenderNeedApprovalAlert
                  toApproved={toApproved}
                  status={status}
                />

                <RenderApprovalButtons
                  elementsRef={elementsRef}
                  toApproved={toApproved}
                  statusInterprete={finderStatusInterprete}
                />

                <PrestationResumeCards registerRef={registerRef} />
                <PrestationSigning
                  toApproved={toApproved}
                  formDisabledResume={formDisabledResume}
                />
                {renderButtonsAnswer()}

                <RenderButtonDraftToNextStage />

                {isEstimation && (
                  <ActionRoleSpecific
                    only={[roles.permanance, roles.admin, roles.institution]}
                  >
                    <PrestationEstimationCost key={id} estimation={true} />
                  </ActionRoleSpecific>
                )}
              </>
            ) : (
              <Card style={{ width: "100%" }}>
                <b>
                  Prestation disponible le{" "}
                  {dayjs(invitationSentAt).format(daysJsFormat.full)}
                </b>
              </Card>
            )}
          </>
        )}
      </Row>
    </div>
  );
}
